<template>
  <div :class="'header h-' + title">
    <div class="header-bg"></div>
    <div class="goback btn-box" @click="goBack" v-if="showBack">
      <i></i>
      <span class="YouSheTitle" data-text="返回">返回</span>
    </div>
    <div v-else></div>
    <span :class="'JLinXin title ' + title"></span>
    <div class="header-right">
      <div class="link-admin" @click="toLink"></div>
      <el-dropdown class="header-icon" placement="bottom" @command="handleCommand">
        <div class="home-admin"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="zh"
            ><i class="i1"></i><i class="i2"></i>综合概况<i class="i3"></i><i class="i4"></i
          ></el-dropdown-item>
          <el-dropdown-item command="sj"
            ><i class="i1"></i><i class="i2"></i>市监大屏<i class="i3"></i><i class="i4"></i
          ></el-dropdown-item>
          <el-dropdown-item command="hy"
          ><i class="i1"></i><i class="i2"></i>会员大屏<i class="i3"></i><i class="i4"></i
          ></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="logout btn-box" @click="logout">
        <span class="YouSheTitle" data-text="退出登录">退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router';
export default {
  name: 'Header',
  props: {
    title: {
      type: String,
      default: 'home',
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    logout() {
      this.$auth.logout();
    },
    goBack() {
      router.go(-1);
    },
    toLink() {
      window.open('https://sqzc.gd.gov.cn/rdzt/ndzchb/index.html');
    },
    handleCommand(command) {
      if (command == 'sj') {
        router.push('/market');
      } else if (command == 'hy'){
        router.push('/member');
      } else {
        router.push('/home');
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  /*width: 3200px;*/
  width: 100%;
  height: 96px;
  /*opacity: 0.71;*/
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -12px;
  position: relative;
  z-index: 99;
  &.h-gather {
    justify-content: space-between;
  }

  &.h-market {
    height: 50px;
    margin: 5px 0 32px;
    .header-bg {
      height: 105px;
      background: url('~img/market/market-title.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('~img/home/header-bg.png') no-repeat;
    background-size: 100% 100%;
  }
  .header-right {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 572px;
    height: 44px;
    background: url('~img/home/header-title.png') no-repeat;
    background-size: 100% 100%;
    &.gather {
      width: 751px;
      height: 44px;
      background: url('~img/gather/gather-bg.png') no-repeat;
      background-size: 100% 100%;
    }
    &.market {
      display: none;
    }
    // font-family: JLinXin;
    // font-size: 46px;
    // font-weight: 400;
    // color: #f1ffff;
    // line-height: 43px;

    // background: linear-gradient(180deg, #83ffff 0%, #d9fafb 100%);
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .header-icon {
    // position: absolute;
    // right: 191px;
    // z-index: 99;
  }
  .link-admin {
    // position: absolute;
    // right: 291px;
    // top: 18px;
    z-index: 99;
    width: 46px;
    height: 46px;
    display: block;
    cursor: pointer;
    background: url('~img/home/header-link.png') no-repeat;
    background-size: 100% 100%;
  }
  .home-admin {
    width: 46px;
    height: 46px;
    display: block;
    cursor: pointer;
    margin-left: 2px;
    background: url('~img/home/header-user.png') no-repeat;
    background-size: 100% 100%;
  }
  .btn-box {
    width: 198px;
    height: 50px;
    background: url('~img/home/header-logout.png') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      position: relative;
      font-size: 24px;
      line-height: 50px;
      font-weight: 400;
      color: #b5c4d0;
      background: none;
      &::before {
        content: attr(data-text);
        display: inline-block;
        font-size: 24px;
        line-height: 50px;
        font-weight: 400;
        background: linear-gradient(
          -72deg,
          rgba(129, 161, 186, 0.44) 0%,
          rgba(255, 255, 255, 0.44) 12.646484375%,
          rgba(137, 161, 181, 0.44) 30.95703125%,
          rgba(255, 255, 255, 0.44) 54.00390625%,
          rgba(141, 176, 204, 0.44) 79.833984375%,
          rgba(255, 255, 255, 0.44) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        position: absolute;
        top: 0;
      }
    }
    // position: absolute;
    // right: 14px;
    cursor: pointer;
    &.goback {
      right: auto;
      left: 0;
      i {
        width: 30px;
        height: 25px;
        display: inline-block;
        margin-right: 5px;
        background: url('~img/home/header-back.png') no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
<style lang="less">
.el-dropdown-menu {
  background: linear-gradient(0deg, rgba(0, 105, 133, 0.8) 0%, #091825 100%);
  border-radius: 3px;
  border: none !important;
  .el-dropdown-menu__item {
    color: #b5c4d0;
    line-height: 38px;
    display: flex;
    align-items: center;
    &:hover {
      background-color: transparent !important;
      color: #fff !important;
      i {
        opacity: 1;
        // &.i2,
        // &.i3 {
        //   opacity: 1;
        // }
      }
    }
    i {
      width: 9px;
      height: 11px;
      display: inline-block;
      background: url('~img/commonImg/header-dropdown.png') no-repeat;
      background-size: 100% 100%;
      opacity: 0;
      &.i1,
      &.i3 {
        margin-right: -2px;
      }
      &.i2 {
        margin-right: 10px;
      }
      &.i3 {
        margin-left: 10px;
      }
      //   &.i2,
      //   &.i3 {
      //     opacity: 0.2;
      //   }
      &.i3,
      &.i4 {
        transform: rotate(180deg);
      }
    }
  }
  .popper__arrow {
    opacity: 0;
  }
}
</style>
